<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>{{ $t("price_list") }}</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-striped price-table">
              <tbody>
                <tr>
                  <th>{{ $t("product") }}</th>
                  <th>{{ $t("credits") }}</th>
                </tr>
                <tr
                  v-for="(item, key) in tuningTypes"
                  v-if="item.is_child !== 1"
                  :key="key"
                >
                  <td><div
                      v-html="item.long_name"
                      class="main_tuning_type_display_name"
                    ></div>
                    <div  v-show="item.children">
                    <h5>Additional options</h5>
                    <table class="table table-striped" style="color: #6f6f6f">
                      <tr
                        v-for="(
                          item_child, key_child
                        ) in showAdditionalTuningTypes(item)"
                        :key="key_child"
                      >
                        <td width="80%">
                          <i class="fas fa-long-arrow-alt-right pull-left" style="margin-right:20px;"></i>
                          <div
                            v-html="item_child.long_name"
                            class="tuning_type_display_name"
                          ></div>
                        </td>
                        <td v-if="item_child.credits > -1">
                          +{{ item_child.credits }}
                        </td>
                        <td v-else>{{ $t("credits.on_request") }}</td>
                      </tr>
                    </table>
                    </div>
                    
                  </td>
                  
                  <td v-if="item.credits > -1" style="vertical-align:top">{{ item.credits }}</td>
                  <td v-else style="vertical-align:top">{{ $t("credits.on_request") }}</td>
                </tr>
                
              </tbody>
            </table>

            <div class="clearfix"></div>
            <hr />
            <div class="btn btn-primary btn-block" @click="printWindow">
              {{ $t("print_list") }}
            </div>
            <div class="clearfix"></div>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Input, Button, Select, Option } from "element-ui";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data: function () {
    return {
      tuningTypes: "",
    };
  },
  mounted: function () {
    this.loadTuningTypes();
  },
  methods: {
    printWindow() {
      window.print();
    },
    loadTuningTypes() {
      if (!this.tuningTypes) {
        Webservice.getProducts("chiptuning").then((resp) => {
          this.tuningTypes = resp.data;
        });
      }
    },

    showAdditionalTuningTypes(item) {
      let items = _.find(this.tuningTypes, {
        id: item.id,
      })
        ? _.find(this.tuningTypes, { id: item.id }).children
        : "";

      return _.filter(items, function (o) {
        return o.is_child == 1;
      });
    },
  },
};
</script>
<style scoped>
.main_tuning_type_display_name {font-weight: bold; font-size:1.4em;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Pricelist.vue